import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Aggressively suppress PostHog and third-party errors
const suppressedPatterns = ['postMessage', 'PerformanceServerTiming', 'posthog', 'DataCloneError'];

const shouldSuppress = (message) => {
  if (!message) return false;
  const msgStr = String(message);
  return suppressedPatterns.some(pattern => msgStr.includes(pattern));
};

// Override console.error
const originalConsoleError = console.error;
console.error = (...args) => {
  const message = args[0];
  if (shouldSuppress(message)) return;
  originalConsoleError.apply(console, args);
};

// Suppress error events
window.addEventListener('error', (event) => {
  if (shouldSuppress(event.message) || shouldSuppress(event.filename)) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

// Suppress unhandled rejections
window.addEventListener('unhandledrejection', (event) => {
  if (shouldSuppress(event.reason?.message) || shouldSuppress(String(event.reason))) {
    event.stopImmediatePropagation();
    event.preventDefault();
    return false;
  }
}, true);

// Hide React error overlay for these errors
if (typeof window !== 'undefined') {
  const hideOverlay = () => {
    const overlay = document.querySelector('iframe[style*="position: fixed"]');
    if (overlay && overlay.contentDocument) {
      const errorText = overlay.contentDocument.body?.innerText || '';
      if (shouldSuppress(errorText)) {
        overlay.style.display = 'none';
      }
    }
    // Also try to find and hide the webpack error overlay
    const webpackOverlay = document.getElementById('webpack-dev-server-client-overlay');
    if (webpackOverlay) {
      const overlayText = webpackOverlay.innerText || '';
      if (shouldSuppress(overlayText)) {
        webpackOverlay.style.display = 'none';
      }
    }
  };
  
  // Run periodically to catch dynamically added overlays
  setInterval(hideOverlay, 100);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
